import { render, staticRenderFns } from "./startup.vue?vue&type=template&id=ca0ce966&"
import script from "./startup.vue?vue&type=script&lang=ts&"
export * from "./startup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports